import styled from 'styled-components'
import { theme } from '../../../style/theme'
import { colorTheme } from '../../../style/theme/colorTheme'

export const CartSettingForDeliveryWrap = styled.div`
	font-size: 1rem;
	max-width: 55em;
	display: grid;
	gap: 1.25em;

	@media screen and (max-width: ${theme.point820}) {
		max-width: 100%;
		margin-bottom: 2.86em;
	}

	@media screen and (max-width: ${theme.point720}) {
		margin-bottom: 2.5em;
	}
`
CartSettingForDeliveryWrap.displayName = 'CartSettingForDeliveryWrap'

export const CartSettingContent = styled.div`
	display: flex;
	padding: 1.25em;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 1.25em;
	border-radius: 0.75em;
	border: 1px solid ${colorTheme.cartSettings.border};
	background: ${colorTheme.cartSettings.background};
`
CartSettingContent.displayName = 'CartSettingContent'

export const CartSettingTitle = styled.div`
	color: ${colorTheme.cartSettings.title};
	font-family: ${theme.fontRobotoMedium};
	font-size: 1.25em;
	font-weight: 600;
`
CartSettingTitle.displayName = 'CartSettingTitle'

export const CartSettingSwitchWrap = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 1.25em;
	width: 100%;

	&.beeper {
		grid-template-columns: repeat(2, 1fr);
	}

	@media screen and (max-width: ${theme.point720}) {
		grid-template-columns: 1fr;

		&.beeper {
			grid-template-columns: 1fr;
		}
	}
`
CartSettingSwitchWrap.displayName = 'CartSettingSwitchWrap'

export const CartSettingSwitchItem = styled.div`
	display: flex;
	padding: 0.63em;
	align-items: center;
	flex: 1 0 0;
	min-height: 3em;
	border-radius: 0.63em;
	border: 1px solid ${colorTheme.cartSettings.switch.border};
	background: ${colorTheme.cartSettings.switch.background};
	transition: all 0.2s ease-in-out;

	input + span .switch-label {
		color: ${colorTheme.cartSettings.switch.label};
		font-family: ${theme.fontRobotoMedium};
		font-size: 1em;
		font-weight: 500;
	}

	input:checked + span .switch-label {
		color: ${colorTheme.cartSettings.switch.activeLabel};
	}

	&.active {
		background: ${colorTheme.cartSettings.switch.activeBackground};
	}
`
CartSettingSwitchItem.displayName = 'CartSettingSwitchItem'
